import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CurrencyPipe, TranslateModule],
  templateUrl: './product-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent {
  product = input.required<any>();
  l_ClassName = input.required<string>();
  s_ClassName = input.required<string>();
  addToCart = output<any>();
  viewDetails = output<any>();

  onAddToCart(event: MouseEvent) {
    event.stopPropagation();
    this.addToCart.emit(this.product());
  }

  onViewDetails() {
    this.viewDetails.emit(this.product());
  }
}